import { useQuery } from "@tanstack/react-query";
import API from "../../api/API";
import { getErrorMessage } from "../../../utils/GeneralUtils";

const useFieldTypes = () => {
  const fieldTypes = useQuery({
    queryKey: ["fieldTypes"],
    queryFn: () =>
      API.getGlobalFieldTypes().then((data) => data.data.data.fieldtypes),
    staleTime: Infinity,
  });

  return {
    fieldTypes: fieldTypes.data,
    fieldTypesLoading: fieldTypes.isLoading,
    fieldTypesError: fieldTypes.error
      ? getErrorMessage(fieldTypes.error)
      : null,
  };
};

export default useFieldTypes;
